export const CERTIFICATE_TYPE = {
  WITH_RATING: 10,
  WITHOUT_RATING: 11,
};

export const CERTIFICATE_CONFIG = {
  [CERTIFICATE_TYPE.WITH_RATING]: {
    title: "Certificate With Rating",
    showRating: true,
    showTick: true,
    savedListKey: "getCertificateAndCostAllocationForWithRatingList",
  },
  [CERTIFICATE_TYPE.WITHOUT_RATING]: {
    title: "Certificate Without Rating",
    showRating: false,
    showTick: false,
    savedListKey: "getCertificateAndCostAllocationForWithoutRatingList",
  },
};